"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authorize = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var core_1 = require("@athena-portal/core");
var Spinner_1 = require("./Spinner");
var services = require("@athena-portal/core");
var Overlay_1 = require("./Overlay");
;
var Authorize = exports.Authorize = /** @class */ (function (_super) {
    __extends(Authorize, _super);
    function Authorize(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            authenticated: _this.applicationGuard.isAuthenticated(),
            loginInProgress: _this.applicationGuard.loginInProgress(),
            user: _this.applicationGuard.getUser()
        };
        return _this;
    }
    /**
     * Component did mount - trigger authentication
     */
    Authorize.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.state.authenticated && !this.state.loginInProgress) {
            this.setState({
                loginInProgress: true
            });
            // Trigger authentication
            this.applicationGuard.doGuard().subscribe(function (authenticated) {
                _this.setState({
                    authenticated: authenticated,
                    loginInProgress: false,
                    user: _this.applicationGuard.getUser()
                });
                if (authenticated) {
                    _this.props.authorizedHook && _this.props.authorizedHook();
                }
            }, function (error) {
                _this.setState({
                    authenticated: false,
                    loginInProgress: false,
                    user: undefined
                });
            });
        }
        else {
            this.props.authorizedHook && this.props.authorizedHook();
        }
    };
    /**
     * Renders component or unauthorized message
     */
    Authorize.prototype.render = function () {
        var roles = [];
        if (this.props.role) {
            roles = Array.isArray(this.props.role) ? this.props.role : [this.props.role];
        }
        if (this.state.authenticated) {
            if (this.isAuthorized(roles)) {
                return (React.createElement(React.Fragment, null, this.props.children));
            }
            return React.createElement(React.Fragment, null);
        }
        else {
            if (this.props.noFeedback) {
                return React.createElement(React.Fragment, null);
            }
            else {
                if (this.state.loginInProgress) {
                    if (process.env.REACT_APP_DEFAULT_OVERLAY && process.env.REACT_APP_DEFAULT_OVERLAY.toString() === "overlay") {
                        return (React.createElement(Overlay_1.default, { show: true }));
                    }
                    else {
                        return (React.createElement(Spinner_1.default, { show: true, className: "mt-3" }));
                    }
                }
                else {
                    return (React.createElement(reactstrap_1.Alert, { color: "danger" }, "Unauthenticated"));
                }
            }
        }
    };
    /**
     * Checks if current user is in any of passed roles
     * @param roles
     */
    Authorize.prototype.hasRole = function (roles) {
        var _this = this;
        if (roles.length === 0) {
            return true;
        }
        if (!this.state.user) {
            return false;
        }
        if (!this.state.user.roles) {
            return false;
        }
        return roles.some(function (role) {
            return _this.state.user.roles.indexOf(role) > -1;
        });
    };
    /**
     * Checks if user is authorized for the component
     */
    Authorize.prototype.isAuthorized = function (roles) {
        return this.isAuthenticated() && this.hasRole(roles);
    };
    /**
     * Check is user is authenticated
     */
    Authorize.prototype.isAuthenticated = function () {
        return this.state.authenticated;
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        __metadata("design:type", Object)
    ], Authorize.prototype, "applicationGuard", void 0);
    return Authorize;
}(React.Component));
//# sourceMappingURL=AuthorizeComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/AuthorizeComponent.js
// module id = 964
// module chunks = 0